import Phaser  from 'phaser';
import ScoreLabel from "./ScoreLabel";
var replayButton

export default class GameOverScene extends Phaser.Scene
{
    constructor()
    {
        super('game-over-scene')
    }

    init(data)
    {
        this.score=data.score
    }

    preload()
    {
        this.load.image('overBackground', 'images/Brown.png')
        this.load.image('replay', 'images/button_replay.png')
        this.load.image('game_over', 'images/gameover.png')
    }

    create()
    {
        this.add.image(240, 320, 'overBackground').setScale(10)
        this.add.image(250, 200, 'game_over')
        replayButton = this.add.image(250, 500, 'replay').setScale(0.8).setInteractive()

        replayButton.on('pointerdown', () => {
            this.scene.start('game-level-1')}, this)
        console.log(this.score)
        // @ts-ignore
        this.add.text(84, 350, 'Score:', {fontSize:'50px', fill:'#000'})
        // @ts-ignore
        this.add.text(265, 350, this.score, {fontSize:'50px', fill:'#000'})
    }
}